import {
  Swiper, Keyboard, Navigation,
} from 'swiper';
import { breakpoints } from '../../../resources/scripts/config/breakpoints';

const swiperContainerClass = '.complex-slider__swiper';
const swiperContainerElement = document.querySelector(swiperContainerClass);
const nextBtnElement = swiperContainerElement.querySelector('.complex-slider__button-next');
const prevBtnElement = swiperContainerElement.querySelector('.complex-slider__button-prev');

let isNavClick = false;

let lastInteractionType = 'mouse';
document.addEventListener('mousedown', () => { lastInteractionType = 'mouse'; });
document.addEventListener('touchstart', () => { lastInteractionType = 'touch'; }, { passive: true });
document.addEventListener('keydown', (e) => {
  if (e.key === 'Tab') {
    lastInteractionType = 'keyboard';
  }
});

nextBtnElement.addEventListener('click', () => {
  isNavClick = true;
});
prevBtnElement.addEventListener('click', () => {
  isNavClick = true;
});

function addFocusClass(slide) {
  if (slide.classList.contains('cs-card')) {
    slide.classList.add('cs-card--focus');
  }
}

function removeFocusClass(slide) {
  if (slide.classList.contains('cs-card--focus')) {
    slide.classList.remove('cs-card--focus');
  }
}

function getCsCards(slider) {
  return slider.el.querySelectorAll('.cs-card');
}

function initSlider(container) {
  const swiper = new Swiper(container, {
    slidesPerView: 'auto',
    spaceBetween: 16,
    threshold: 10,
    modules: [Keyboard, Navigation],
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: '.complex-slider__button-next',
      prevEl: '.complex-slider__button-prev',
      disabledClass: 'c-arrow--disabled',
    },
    on: {
      slideChange() {
        if (window.innerWidth < breakpoints.lg) {
          this.wrapperEl.style.transform = `translate3d(-${this.slides[this.activeIndex].offsetLeft - 16}px, 0, 0)`;
        }
      },
      afterInit() {

      },
      reachEnd() {
        if (isNavClick) {
          setTimeout(() => {
            prevBtnElement.focus({ preventScroll: true });
          }, 0);
          isNavClick = false;
        }
      },
      reachBeginning() {
        if (isNavClick) {
          setTimeout(() => {
            nextBtnElement.focus({ preventScroll: true });
          }, 0);
          isNavClick = false;
        }
      },
    },
  });

  // Get all slides
  const slides = swiper.el.querySelectorAll('.complex-slider__slide');

  if (window.innerWidth > breakpoints.lg) {
    // Get all cs-card elements
    const csCards = getCsCards(swiper);

    // Get the last and first slide
    const lastSlide = csCards[csCards.length - 1];
    const firstSlide = slides[0];

    // Add event listeners for focus and blur
    slides.forEach((slide, index) => {
      const link = slide.querySelector('.c-button');

      slide.addEventListener('focus', () => {
        addFocusClass(slide);
        if (lastInteractionType === 'keyboard') {
          swiper.slideTo(index, 700, false);
        }
      });

      slide.addEventListener('blur', () => {
        removeFocusClass(slide);
      });

      if (link) {
        link.addEventListener('focus', () => {
          addFocusClass(slide);
          if (lastInteractionType === 'keyboard') {
            swiper.slideTo(index, 700, false);
          }
        });

        link.addEventListener('blur', () => {
          removeFocusClass(slide);
        });
      }
    });

    // Add mouseover and mouseout event listeners for LastSlide
    lastSlide.addEventListener('mouseenter', () => {
      firstSlide.classList.add('cs-card-main--width');
    });

    lastSlide.addEventListener('mouseleave', () => {
      firstSlide.classList.remove('cs-card-main--width');
    });

    // Add focus and blur event listeners for LastSlide
    lastSlide.addEventListener('focus', () => {
      firstSlide.classList.add('cs-card-main--width');
    });

    lastSlide.addEventListener('blur', () => {
      firstSlide.classList.remove('cs-card-main--width');
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const initAllSliders = () => {
    const sliderContainers = document.querySelectorAll(swiperContainerClass);
    sliderContainers.forEach((el) => {
      initSlider(el);
    });
  };

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/slider', () => {
      initAllSliders();
    });
  } else {
    initAllSliders();
  }
});
